var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "516.9,10.5 503.7,0.6 493.8,13.8 254.5,299.4 183.5,213.6 173.6,202 160.4,211.9 122.4,241.6 109.2,253.2  119.1,266.4 241.3,413.3 252.8,429.8 266,413.3 558.2,65 568.1,53.5 554.9,41.9 ",
    fill: "#107eab"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.6,465.9 46,465.9 46,66.3 348.1,66.3 386.1,21 0.7,21 0.7,511.3 491,511.3 491,266.4 445.6,320.5 ",
    fill: "#107eab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareChecked);
export default __webpack_public_path__ + "static/media/square-checked.0a2de190f9edf7281481f1a013442ebf.svg";
export { ForwardRef as ReactComponent };